import moment from "moment";
import { IntlShape } from "react-intl";
import { formatDateTime } from "../../../../utils/datetime";
import { MONITOR_LIVE_PRESSA_STATUSES } from "./constants";
import { MonitorLiveDaMesModel } from "../../../../api/live-monitor/models";

export type LegendItemProps = {
  title?: string | undefined;
  className?: string | undefined;
};

export function getStatusColor(stato_def?: number): string {
  switch (stato_def) {
    case MONITOR_LIVE_PRESSA_STATUSES.PRODUZIONE:
      return "bg-success";
    case MONITOR_LIVE_PRESSA_STATUSES.SOTTOPRODUZIONE:
      return "bg-danger";
    case MONITOR_LIVE_PRESSA_STATUSES.FERMO_MACCHINA:
      return "bg-warning";
    case MONITOR_LIVE_PRESSA_STATUSES.ATTREZZAGGIO:
      return "bg-primary";
    default:
      return "bg-dark";
  }
}

export function getStatusColorItaltex(stato_fisico?: number): string {
  switch (stato_fisico) {
    case 1:
      return "bg-success";

    //17-11-25: Se il passaggio da 0-1 è maggiore di un minuto, vuol dire che la macchina è ferma --- colore giallo 
    case 2:
      return "bg-warning";
    default:
      return "bg-dark";
  }
}

export function getStatusName(intl: IntlShape, stato_def?: number): string {
  switch (stato_def) {
    case MONITOR_LIVE_PRESSA_STATUSES.PRODUZIONE:
      return intl.formatMessage({ id: "monitor.status_produzione" });
    case MONITOR_LIVE_PRESSA_STATUSES.SOTTOPRODUZIONE:
      return intl.formatMessage({ id: "monitor.status_sotto_produzione" });
    case MONITOR_LIVE_PRESSA_STATUSES.FERMO_MACCHINA:
      return intl.formatMessage({ id: "monitor.status_fermo_macchina" });
    case MONITOR_LIVE_PRESSA_STATUSES.ATTREZZAGGIO:
      return intl.formatMessage({ id: "monitor.status_attrezzaggio" });
    default:
      return "";
  }
}

export function formatMonitorTime(value?: string): string {
  return value ? moment(value, "HH:mm:ss.Z").format("HH[h]mm[m]ss[s]") : "";
}

export const showRow = (
  intl: IntlShape,
  name: string,
  value?: string,
  small?: string
) => {
  const labelClassNames = "text-dark fw-bolder text-hover-primary mb-1 fs-7";
  return (
    <tr className="pb-0">
      <td className="pb-0">
        <span className={labelClassNames}>
          {intl.formatMessage({ id: `monitor.${name}` })}
        </span>
      </td>
      <td className="pb-0 text-end text-muted fw-bold">
        {value ?? ""}
        {small && <>&nbsp;/&nbsp;{small}</>}
      </td>
    </tr>
  );
};

export const showRowInt = (intl: IntlShape, name: string, value?: string) => {
  let val: string = "";

  //Check if is a number
  if (!isNaN(Number(value))) {
    val = Number(value).toFixed(0);
  }

  return showRow(intl, name, val);
};

export const showRowFloat = (intl: IntlShape, name: string, value?: string) => {
  let val: string = "";

  //Check if is a number
  if (!isNaN(Number(value))) {
    const formatterIT = new Intl.NumberFormat("it-IT");
    val = formatterIT.format(Number(value));
  }

  return showRow(intl, name, val);
};

export const showRowDateTime = (
  intl: IntlShape,
  name: string,
  value?: string
) => {
  let val: string = "";

  //Check if is a number
  const d = moment(value, "YYYY-MM-DD HH:mm:ss.SSS");
  if (d.isValid()) {
    val = formatDateTime(value);
  }

  return showRow(intl, name, val);
};

export const formatDateStringToTime = (value?: string): string => {
  return value ? moment(value, "YYYY-MM-DD HH:mm:ss.SSS").format("HH:mm") : "";
};

export function pezziOraVisualizzabili(item: MonitorLiveDaMesModel): boolean {
  return (
    item.stato_def !== MONITOR_LIVE_PRESSA_STATUSES.FERMO_MACCHINA &&
    item.stato_def !== MONITOR_LIVE_PRESSA_STATUSES.ATTREZZAGGIO
  );
}

export function formattaPezziOra(item: MonitorLiveDaMesModel): string {
  return item.num_pezzi_ora !== undefined && item.num_pezzi_ora !== null
    ? `${item.num_pezzi_ora} p/h`
    : "";
}

export function teoricoVisualizzabile(item: MonitorLiveDaMesModel): boolean {
  return item.stato_def !== MONITOR_LIVE_PRESSA_STATUSES.ATTREZZAGGIO;
}

export function formattaTeorico(item: MonitorLiveDaMesModel): string {
  return item.qta_oraria_nominale !== undefined &&
    item.qta_oraria_nominale !== null
    ? `T. ${item.qta_oraria_nominale} p/h`
    : "";
}
